import { ServiceHandler } from '../../../../../../../utils';
import type { FirmoDataPayload } from '../primeTech/types';
import type {
  ClassDescriptionsResponseData,
  GetSupplementalFirmoDataResponse,
} from './types';

export const getFormData = ServiceHandler<
  unknown,
  GetSupplementalFirmoDataResponse
>({
  url: '/api/account/v1/questions/:accountId/forms/:formId',
});

export const saveFormData = ServiceHandler<FirmoDataPayload, unknown>({
  url: '/api/account/v1/questions/:accountId/fields/key',
  method: 'POST',
});

export const getClassDescriptions = ServiceHandler<
  unknown,
  ClassDescriptionsResponseData
>({
  url: '/api/account/v1/risk-classification-system/subset/:productKey/:partialCode',
});

export const getClassDescriptionsWithVersion = ServiceHandler<
  unknown,
  ClassDescriptionsResponseData
>({
  url: '/api/account/v1/risk-classification-system/subset/:productKey/:partialCode/:productVersion',
});
